import { connect } from 'react-redux';
import PageViewer from '../components/Game/PageViewer';
import {
  toggleGameModal,
  setGameView,
  levelUp,
  changeGameLevel,
} from '../actions/game';
import { gotoDesignChallenge } from '../actions/research';

const mapStateToProps = (state) => {
  return {
    page: state.game.page,
    game: state.game,
    gameMode: state.app.gameMode,
    competition: state.app.competition,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onHide: () => {
    dispatch(toggleGameModal());
  },
  setGameView: (page) => {
    dispatch(setGameView(page));
  },
  toggleGameModal: () => {
    dispatch(toggleGameModal());
  },
  levelUp: () => {
    dispatch(levelUp());
  },
  gotoDesignChallenge: () => {
    dispatch(toggleGameModal());
    dispatch(gotoDesignChallenge());
  },
  changeGameLevel: (levelid) => {
    dispatch(changeGameLevel(levelid));
  },
});

const GameModal = connect(mapStateToProps, mapDispatchToProps)(PageViewer);

export default GameModal;
